import React, { memo } from 'react';
import { Dialog, ErrorButton, PrimaryButton } from '@beeline.com/bp-design-system';
import { useImportersIntl } from '../../../translations/useImportersIntl';

interface Props {
  open: boolean;
  engagementCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DiscardConfirmationDialog = memo(({ open, engagementCount, onConfirm, onCancel }: Props) => {
  const intl = useImportersIntl();

  return (
    <Dialog
      open={open}
      title={intl.discardPendingChanges}
      subTitle={intl.discardPendingChangesBody({ count: engagementCount })}
      onClose={onCancel}
      dataTest="discard-pending-changes-dialog"
      actions={[
        <ErrorButton.Text key="confirm" dataTest="discard-confirm" onClick={onConfirm}>
          {intl.importAndDiscard}
        </ErrorButton.Text>,
        <PrimaryButton.Contained key="cancel" dataTest="discard-cancel" onClick={onCancel}>
          {intl.goBack}
        </PrimaryButton.Contained>
      ]}
    />
  );
});
